import styles from './BookmarkButton.module.css'
import { useBookmarkActions } from '../../hooks/useBookmarkActions'

interface Props {
    routePath: string
}

export const BookmarkButton = ({ routePath }: Props) => {
    const { isBookmarked, isMaxReached, addBookmark, removeBookmark } = useBookmarkActions()
    const bookmarked = isBookmarked(routePath)
    const disabled = !bookmarked && isMaxReached

    const tooltipContent = bookmarked
        ? <>Quitar de<br />favoritos</>
        : disabled
        ? <>Límite alcanzado.<br />Quitá un favorito<br />para agregar otro.</>
        : <>Agregar a<br />favoritos</>

    const handleClick = () => {
        if (disabled) return
        bookmarked ? removeBookmark(routePath) : addBookmark(routePath)
    }

    return (
        <div className={styles.container}>
            <button
                type="button"
                className={`${styles.btn} ${bookmarked ? styles.active : ''} ${disabled ? styles.disabled : ''}`}
                onClick={handleClick}
                disabled={disabled}
            >
                <i className={`bi bi-${bookmarked ? 'star-fill' : 'star'}`} />
            </button>
            <div className={styles.tooltip}>{tooltipContent}</div>
        </div>
    )
}
